import { AppointmentType } from '@src/lib/__generated/vetspire/sdk';

export const stringifyAppointmentTypes = (appointmentTypes: AppointmentType[] | null): string | null => {
	return appointmentTypes?.map(({ id, name }) => `${id} - ${name}`).join(', ') ?? null;
};
